import { NavLink, Outlet } from "react-router-dom";

import { AuthControls } from "../auth";
import { trpc } from "../trpc";

function navClass({ isActive }: { isActive: boolean }): string {
  return [
    "relative py-1 text-sm transition-colors",
    isActive ? "text-ink" : "text-ink-faint hover:text-ink",
  ].join(" ");
}

export function Layout() {
  const me = trpc.session.me.useQuery();
  const role = me.data?.role;
  const approved = me.data?.approved ?? false;
  const isHelper = role === "helper" || role === "admin";
  const isAdmin = role === "admin";
  const isPending = Boolean(me.data) && !approved;

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-20 border-b border-line bg-paper/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5 sm:px-8">
          <NavLink to="/" className="group flex items-baseline gap-2">
            <span className="font-deva text-2xl leading-none text-terracotta">
              अ
            </span>
            <span className="font-display text-xl tracking-wide text-ink">
              Swarved
            </span>
          </NavLink>
          <nav className="flex items-center gap-5 sm:gap-6">
            <NavLink to="/glossary" className={navClass}>
              Glossary
            </NavLink>
            <NavLink to="/graph" className={navClass}>
              Graph
            </NavLink>
            <NavLink to="/dohas" className={navClass}>
              Dohas
            </NavLink>
            {approved ? (
              <NavLink to="/study" className={navClass}>
                Study
              </NavLink>
            ) : null}
            {approved ? (
              <NavLink to="/drill" className={navClass}>
                Drill
              </NavLink>
            ) : null}
            {isHelper ? (
              <NavLink to="/helper" className={navClass}>
                Requests
              </NavLink>
            ) : null}
            {isAdmin ? (
              <NavLink to="/admin" className={navClass}>
                Admin
              </NavLink>
            ) : null}
            {approved ? (
              <NavLink
                to="/capture"
                className="rounded-full bg-ink px-4 py-1.5 text-sm font-medium text-paper transition-opacity hover:opacity-90"
              >
                Capture
              </NavLink>
            ) : null}
            {isPending ? (
              <span className="hidden text-xs text-ink-faint sm:inline">
                pending approval
              </span>
            ) : null}
            <div className="ml-1">
              <AuthControls />
            </div>
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="mx-auto max-w-6xl px-5 pb-12 pt-20 sm:px-8">
        <div className="border-t border-line pt-6">
          <p className="font-serif text-sm italic text-ink-faint">
            A study of the Swarveda — word by word, doha by doha.
          </p>
        </div>
      </footer>
    </div>
  );
}
